module.exports = __webpack_public_path__ + "static/media/Acrilico (34).4703ece6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (34).jpg
// module id = 302
// module chunks = 0